import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@/store';

import { DatadogManager } from './datadogManager';

export const useDatadog = () => {
  const user = useSelector((store: RootState) => store.user);
  const [userLoaded, setUserLoaded] = useState(false);

  useEffect(() => {
    if (!userLoaded && user?.userId && user?.email && user?.displayName) {
      DatadogManager.setUser({
        id: user.userId,
        email: user.email,
        name: user.displayName,
      });
      setUserLoaded(true);
    }
  }, [user, userLoaded]);

  return {};
};
